import type { NftMiniature } from "@anaconda/core/nft/types"
import { toCurrencyId } from "@anaconda/core/price/types"
import { useMolecule } from "bunshi/react"
import { useCallback, useMemo } from "react"
import { useSwitchEvmChain } from "../../use-switch-evm-chain"
import { EvmItemOfferTransactionMoleculeReatom } from "./evm-item-offer-molecule.reatom"

interface EvmItemOfferParams {
  price: number
  currency: string
}

export function useEvmItemOffer(nft: NftMiniature) {
  const { itemOfferActionFactory } = useMolecule(
    EvmItemOfferTransactionMoleculeReatom,
  )
  const itemOfferAction = useMemo(
    () => itemOfferActionFactory(),
    [itemOfferActionFactory],
  )

  const onSuccess = useCallback(
    (params: EvmItemOfferParams) => {
      itemOfferAction({
        nft,
        currency: toCurrencyId(params.currency),
        price: params.price.toString(),
      }).catch(() => undefined)
    },
    [itemOfferAction, nft],
  )

  const { action, switchInProgress } = useSwitchEvmChain<EvmItemOfferParams>(
    nft.collection.blockchain,
    onSuccess,
  )

  return {
    mutate: action,
    isPending: !!itemOfferAction.pending() || switchInProgress,
  }
}
